import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {searchLeadByCustomer} from "../../../../../../services/api/apiCustomers"
import parseToken from "../../../../../../helpers/parseToken"
import {Pagination} from "antd"
import LeadTable from "./table/LeadTable"

BlockCenter.propTypes = {
    custId: PropTypes.string
}

function BlockCenter(props) {
    const decodeToken = parseToken()
    const {custId} = props
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [limit, setLimit] = useState(7)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [listLead, setListLead] = useState([])

    const _onChangeLimit = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a href={() => false}>Previous</a>
        }
        if (type === 'next') {
            return <a href={() => false}>Next</a>
        }
        return originalElement
    }

    const _fetchListLead = async () => {
        try {
            const payload = {
                page,
                limit,
                custId: custId
            }

            const response = await searchLeadByCustomer(payload, decodeToken.sub)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setListLead(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    useEffect(() => {
        _fetchListLead()
        // eslint-disable-next-line
    }, [limit, page])


    return (
        <div className="BlockCenter">
            <div className="ContentTab mt-0">
                <div className="TabNav">
                    <ul>
                        <li className="Active">
                            Danh sách Lead
                        </li>
                    </ul>
                </div>
                <div className="CustomersPage CustomerLeadPage">
                    <div className="ContentPage">
                        <LeadTable
                            loading={loading}
                            page={page}
                            limit={limit}
                            error={error}
                            listLead={listLead}
                        />
                        <div className="FooterTable">
                            <div className="Total">Total {total} items</div>
                            <Pagination
                                className="PaginationCustom"
                                showSizeChanger={false}
                                total={total}
                                current={page}
                                pageSize={limit}
                                itemRender={itemRender}
                                onChange={_onChangeLimit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlockCenter
